
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.05 16.5h-1.1a.55.55 0 01-.55-.55V6.6h-3.85a.55.55 0 01-.55-.55v-1.1a.55.55 0 01.55-.55h9.9a.55.55 0 01.55.55v1.1a.55.55 0 01-.55.55H17.6v9.35a.55.55 0 01-.55.55zm-9.9 0h-1.1a.55.55 0 01-.55-.55V2.2H.55A.55.55 0 010 1.65V.55A.55.55 0 01.55 0h12.1a.55.55 0 01.55.55v1.1a.55.55 0 01-.55.55H7.7v13.75a.55.55 0 01-.55.55z"}})])
          )
        }
      }
    